// components/Feature.jsx
import React from 'react';
import { useEntitlements } from '../context/EntitlementsContext';

// Ranks for comparing plans
const PLAN_RANK = { demo: 0, monthly: 1, yearly: 2, lifetime: 3 };

/**
 * Props:
 * - name?: string       // feature flag key, e.g. "customDataUpload"
 * - minPlan?: 'demo' | 'monthly' | 'yearly' | 'lifetime'  // minimum plan required
 * - fallback?: ReactNode
 */
export default function Feature({ name, minPlan = 'demo', children, fallback = null }) {
  const ent = useEntitlements();
  if (!ent || ent.__loading) return null;

  const hasFeature = name ? !!ent.features?.[name] : true;
  const meetsPlan = (PLAN_RANK[ent.plan] ?? 0) >= (PLAN_RANK[minPlan] ?? 0);

  const allowed = hasFeature || meetsPlan; // pass if either the flag is on OR plan meets minimum
  return allowed ? <>{children}</> : <>{fallback}</>;
}
